import React from 'react'
import Component from '@reactions/component'
import Session from './Session'
import { Redirect, Route } from 'react-router-dom'
import { withNotifier } from 'stylist'

const RouteUnlessAuthenticated = ({ component: Comp, to, notify, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <Session
        render={({ isAuthenticated }) => (
          <Component
            didMount={() =>
              isAuthenticated && notify('warning', 'You are already signed in.')
            }
            render={() =>
              isAuthenticated ? <Redirect to={to} /> : <Comp {...props} />
            }
          />
        )}
      />
    )}
  />
)

export default withNotifier(RouteUnlessAuthenticated)



// WEBPACK FOOTER //
// ./src/components/RouteUnlessAuthenticated.js